import en_US from './en_US';

export default {
	en_US,
	de_DE: {},
	es_ES: {},
	es_MX: {},
	fr_FR: {},
	it_IT: {},
	ja_JP: {},
	ko_KR: {},
	ms_MY: {},
	pt_BR: {},
	pt_PT: {},
	ru_RU: {},
	th_TH: {},
	tr_TR: {},
	zh_HK: {},
	zh_TW: {},
};
